import React from 'react'
import Category from './Category'
import front from '../images/front2.png'
import end from '../images/back.jpg'
import frame from '../images/frame.jpg'


function Skill() {
  return (
    <div>
      <div className='font-light text-4xl md:text-6xl flex justify-center mt-[35px] md:mt-[20px]'>Skills & Experience </div> 
      <div className=''>
        <Category gray={true} logo={front}  isimg={true} top={"Frontend"} middle={"Html,css,javascript"} end={"Framework -Reactjs"}/>
        <Category gray={false} logo={end} isimg={true} top={"Backend"} middle={"Nodejs, express, ejs"} end={"Framework -Firebase"}/>
        <Category gray={true} logo={frame} isimg={true} top={"Database"} middle={"Nosql-mongoDb"} end={"Framework -Mongoose"}/>
      </div>
    </div>
  )
}

export default Skill
